'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _warning = require('warning');

var _warning2 = _interopRequireDefault(_warning);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _ = require('../');

var _2 = _interopRequireDefault(_);

var _styles = require('./styles.css');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var cn = _bind2.default.bind(_styles2.default);

var RadioButtonGroup = function (_Component) {
  _inherits(RadioButtonGroup, _Component);

  function RadioButtonGroup() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RadioButtonGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RadioButtonGroup.__proto__ || Object.getPrototypeOf(RadioButtonGroup)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      selected: ''
    }, _this.handleChange = function (newSelection) {
      _this.setState({
        selected: newSelection
      });

      if (_this.props.onChange) _this.props.onChange(newSelection);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RadioButtonGroup, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.setState({
        selected: this.props.valueSelected || this.props.defaultSelected || ''
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.valueSelected !== this.state.selected) {
        this.setState({
          selected: nextProps.valueSelected
        });
      }
    }
  }, {
    key: 'hasCheckAttribute',
    value: function hasCheckAttribute(radioButton) {
      return radioButton.props.hasOwnProperty('checked') && radioButton.props.checked;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var options = _react2.default.Children.map(this.props.children, function (option) {
        if (option.props.checked) {
          (0, _warning2.default)(false, 'To set the checked radio, use RadioButtonGroups `valueSelected`');
        }

        return _react2.default.createElement(
          _2.default,
          {
            ref: option.props.value,
            env: _this2.props.env,
            inline: _this2.props.inline,
            name: _this2.props.name,
            key: option.props.value,
            value: option.props.value,
            onCheck: _this2.handleChange,
            checked: option.props.value === _this2.state.selected,
            disabled: option.props.disabled
          },
          option.props.children
        );
      });

      var groupStyles = cn({
        'radio-button-group': !this.props.inline,
        'radio-button-group--inline': this.props.inline
      });

      return _react2.default.createElement(
        'div',
        {
          className: groupStyles
        },
        options
      );
    }
  }]);

  return RadioButtonGroup;
}(_react.Component);

RadioButtonGroup.propTypes = {
  children: _react.PropTypes.node,
  className: _react.PropTypes.string,
  defaultSelected: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
  name: _react.PropTypes.string,
  env: _react.PropTypes.oneOf(['light', 'dark']),
  inline: _react.PropTypes.bool,
  onChange: _react.PropTypes.func,
  valueSelected: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number])
};
RadioButtonGroup.defaultProps = {
  env: 'light',
  inline: false
};
exports.default = RadioButtonGroup;